import { Controller } from "@hotwired/stimulus"

// Phase 2.5 Tier 4 — CIP Scenario form (fund_shifts + project_shifts).
//
// Fund-shift and project-shift rows are added/removed dynamically. Each
// row has a `[__INDEX__]` placeholder in its template that we replace
// with a unique sequence so Rails parses them as an array of hashes.
export default class extends Controller {
  static targets = [
    "fundShiftsContainer", "fundShiftTemplate", "fundShiftRow",
    "projectShiftsContainer", "projectShiftTemplate", "projectShiftRow"
  ]

  addFundShift(event) {
    event.preventDefault()
    this._appendFromTemplate(this.fundShiftTemplateTarget, this.fundShiftsContainerTarget)
  }

  addProjectShift(event) {
    event.preventDefault()
    this._appendFromTemplate(this.projectShiftTemplateTarget, this.projectShiftsContainerTarget)
  }

  removeRow(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-cip-scenario-form-target='fundShiftRow'], [data-cip-scenario-form-target='projectShiftRow']")
    if (row) row.remove()
  }

  _appendFromTemplate(template, container) {
    const html = template.innerHTML.replaceAll("__INDEX__", this._nextIndex())
    container.insertAdjacentHTML("beforeend", html)
  }

  _nextIndex() {
    this._counter = (this._counter || Date.now()) + 1
    return this._counter
  }
}
